module.exports = {
  DomesticTrade: '内贸',
  SiruiPleaseContactTheTroubleshooting: '思锐委托单推送失败,请联系工作人员排查:',
  OperationFailed: '操作失败',
  PleaseCheckTheData: '请勾选数据',
  LockedContactAHigherUnlock: '已被锁定,不能打印,请联系上级主管解锁!',
  AreCancelTheVoidingDocuments: '确定要取消作废选中的单据吗？',
  PleaseFormInvoiceEtcVoid: '请先删除费用确认单、账单等, 然后作废。',
  PleaseFromTheMasterVoid: '请从主票移出这一小票，然后作废。',
  PleaseFromThisMasterVoid: '请从这一主票移出所有小票，然后作废。',
  ThisThatRelevantDocumentsContinue: '本单业务将提交财务审核，提交前请确认相关文件已经上传系统，是否继续？',
  AttachmentContentIsTooLarge: '附件内容过大',
  ThereBillNumbersProfitPrinted: '有国外费用没有有效账单号，不能打印利润分析表！',
  ThereBillNumbersProfitSubmitted: '有国外费用没有有效账单号，不能提交利润分析表！',
  LockedPrintedOrEDINeeded: '由于信控超出,本票已被锁定,将不能打印或者EDI,请需要时联系上级解锁!',
  PleaseTicketToBeAdded: '请选择要加入的小票',
  AreCopyTheMastersInformation: '确定要抄录主单收发货人信息吗？',
  MasterPleaseMaintainTheFirst: '主单号不能为空，请先维护主单号',
  PleaseTicketToBeEdited: '请选择要编辑的小票',
  Add: '新增',
  AirImportCargoOperationDetails: '空运进口货物操作明细',
  ThisAlreadyAFormalBusiness: '本票已是正式业务.'
}
